import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './claimSavedSuccess.scss';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { scrollElementIntoView } from '../../../utils/scrollUtils';

const ClaimSavedSuccess = ({ title = 'Claim successfully saved', copy, hideButton = false }) => {
  const navigate = useNavigate();
  const saveClaimSuccessRef = useRef(null);

  useEffect(() => {
    if (saveClaimSuccessRef?.current) {
      scrollElementIntoView(saveClaimSuccessRef.current);
    }
  }, [saveClaimSuccessRef]);

  return (
    <section
      className="claimSavedSuccessContainer"
      ref={saveClaimSuccessRef}
    >
      <h2>{title}</h2>
      <Icon icon="save" />
      <h3>
        Your claim has been saved and can be accessed via <a href={CSPUrlsMap.myClaims.url}>My claims</a>.
      </h3>
      <p>{copy}</p>
      {!hideButton && (
        <button
          type="button"
          className="button outline"
          onClick={() => navigate(CSPUrlsMap.dashboard.url)}
        >
          Back to Dashboard
        </button>
      )}
    </section>
  );
};

export default ClaimSavedSuccess;

ClaimSavedSuccess.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string.isRequired,
  hideButton: PropTypes.bool
};
